import React from "react";

const colorMap = {
  green: "bg-status-success-bg text-status-success-text",
  purple: "bg-status-info-bg text-brand-purple",
};

export default function Badge({ color = "green", children, className = "" }) {
  return (
    <span
      className={`self-start px-3 py-1.5 rounded-full  font-bold text-[13px] tracking-[0.04em] uppercase ${
        colorMap[color] || colorMap.green
      } ${className}`}
    >
      {children}
    </span>
  );
}
